import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "percentSign" })
export class PercentSign implements PipeTransform {
  transform(value: number): string {
    return `${value}%`;
  }
}
